export const title = state => state.view.title
export const theme = state => state.view.theme
export const loading = state => state.view.isLoading
export const backRoute = state => state.view.backRoute



// WEBPACK FOOTER //
// ./src/vuex/view/getters.js